module.exports = __webpack_public_path__ + "media/country_flags/kg-09aacdd9.png";